import React from 'react';
const nodeContext = React.createContext({
    editor: undefined,
    node: undefined,
    view: undefined,
    getPos: undefined,
    decorations: undefined,
});
export const ReactNodeContainer = ({ editor, node, view, getPos, decorations, children }) => {
    return React.createElement(nodeContext.Provider, { value: { editor, node, view, getPos, decorations } }, children);
};
export const useNodeCtx = () => React.useContext(nodeContext);
export const Content = ({ dom, isMark }) => {
    const containerRef = React.useRef(null);
    React.useEffect(() => {
        const { current } = containerRef;
        if (!current || !dom)
            return;
        current.appendChild(dom);
    }, [dom]);
    if (isMark) {
        return React.createElement("span", { className: "content-dom-wrapper", ref: containerRef });
    }
    return React.createElement("div", { className: "content-dom-wrapper", ref: containerRef });
};
//# sourceMappingURL=ReactNode.js.map